<div
  class="flex h-full flex-col gap-5 overflow-hidden rounded transition-transform duration-100 active:scale-105"
  [style.backgroundColor]="cardColor() | contentBuilderColor"
  [style.color]="textColor() | contentBuilderColor"
  (click)="selectionnable() || !effectiveIsProductAvailable ? null : addToCart()"
  [class.cursor-pointer]="effectiveIsProductAvailable && isOrderingAllowed()"
  [class.pointer-events-none]="!effectiveIsProductAvailable || !isOrderingAllowed()"
>
  <div class="relative flex h-full flex-col justify-between gap-5 pb-4">
    @let showProductInfoIcon =
      isShowProductIcon() && !!(product().description?.length || product().allergens?.length);

    <div class="m-auto flex max-w-44 flex-col pb-8">
      <div class="my-2 flex w-full items-end">
        @if (showProductInfoIcon) {
          <span
            class="w-[1.875rem] shrink-0"
            aria-hidden="true"
          ></span>
        }
        <p
          class="min-w-0 flex-1 line-clamp-2 h-12 content-end overflow-hidden text-center align-bottom font-accent text-base font-bold"
          [class.px-1]="!showProductInfoIcon"
        >
          {{ product()[ProductKeys.Name] }}
        </p>
        @if (showProductInfoIcon) {
          <i
            (click)="
              !effectiveIsProductAvailable ? null : showProductModal(); $event.stopPropagation()
            "
            class="icon icon-c-info-3 pointer-events-auto inline-flex h-5 w-5 shrink-0 items-center justify-center text-xl font-semibold"
            [style.color]="textColor() | contentBuilderColor"
            [class.opacity-50]="!effectiveIsProductAvailable || !isOrderingAllowed()"
          ></i>
          <span
            class="w-2.5 shrink-0"
            aria-hidden="true"
          ></span>
        }
      </div>

      <div class="kiosk-card-image relative m-auto aspect-square h-44 w-44 rounded">
        <!-- Gradient Background -->
        <div
          class="absolute inset-0 h-44 w-44"
          [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
        ></div>

        <!-- Product Image -->
        @if (product().images?.thumbnail?.url) {
          <img
            class="relative z-10 h-44 w-44 object-cover"
            [src]="product().images?.thumbnail?.url"
            [alt]="product()[ProductKeys.Name]"
          />
        }
      </div>

      <div class="relative z-40 flex flex-col flex-wrap backdrop-grayscale">
        <div class="absolute -bottom-5 flex w-full justify-center text-center">
          @if (displayPrice()) {
            <div
              class="flex flex-row px-2 py-1 text-2xl font-bold"
              [style.backgroundColor]="cardColor() | contentBuilderColor"
            >
              @if (displayDiscount(product())) {
                <app-price-atom
                  size="2XL"
                  class="mr-1"
                  [priceColor]="priceColor()"
                  [amount]="product()[ProductKeys.Discount] ?? 0"
                  [semiBold]="true"
                  [whiteOutline]="true"
                ></app-price-atom>
                @if (product()[ProductKeys.Price]) {
                  <app-price-atom
                    class="mr-1"
                    size="L"
                    [priceColor]="priceColor()"
                    [amount]="product()[ProductKeys.Price]"
                    [discount]="true"
                    [semiBold]="true"
                    [whiteOutline]="true"
                  ></app-price-atom>
                }
              } @else {
                @if (!product()[ProductKeys.PriceToDisplay]) {
                  <app-price-atom
                    class="mr-1"
                    size="2XL"
                    [priceColor]="priceColor()"
                    [amount]="product()[ProductKeys.Price]"
                    [discount]="_hasDiscountPromotionLabel"
                    [semiBold]="true"
                    [whiteOutline]="true"
                  ></app-price-atom>
                } @else {
                  <app-price-atom
                    class="mr-1"
                    size="2XL"
                    [priceColor]="priceColor()"
                    [amount]="$any(product()[ProductKeys.PriceToDisplay])"
                    [discount]="_hasDiscountPromotionLabel"
                    [semiBold]="true"
                    [whiteOutline]="true"
                  ></app-price-atom>
                }
              }
            </div>
          }

          @if (!displayPrice() && displayedAddition()) {
            <div
              class="flex flex-row px-2 py-1 text-2xl font-bold"
              [style.backgroundColor]="cardColor() | contentBuilderColor"
            >
              <span class="text-2xl font-semibold">+</span>
              <app-price-atom
                class="mr-1"
                size="2XL"
                [priceColor]="priceColor()"
                [amount]="displayedAddition()! / 100"
                [semiBold]="true"
                [whiteOutline]="true"
              ></app-price-atom>
            </div>
          }
        </div>
      </div>
    </div>

    @if (!effectiveIsProductAvailable || !isOrderingAllowed()) {
      <div class="absolute flex h-full w-full flex-row flex-wrap items-center justify-center gap-5">
        @if (!canSelect) {
          <div class="z-30">
            @if (!effectiveIsProductAvailable || !isOrderingAllowed()) {
              <app-button-atom
                size="S"
                [label]="'_.UNAVAILABLE' | translate"
                thickSize="XS"
                [overrideBgColor]="unavailableButtonBackground()"
                [overrideTextColor]="unavailableButtonText()"
                type="kiosk-primary"
                [full]="true"
              ></app-button-atom>
            }
          </div>
        }
        <div
          class="pointer-events-none absolute h-full w-full opacity-80"
          [class.bg-neutral-400]="!effectiveIsProductAvailable || !isOrderingAllowed()"
        ></div>
      </div>
    }

    @if (canSelect && !monoSelection()) {
      @if ((displayedQuantity() > 0 && maxProduct() > 1) || displayedQuantity() > 1) {
        <div class="flex flex-row items-center justify-center px-4">
          <app-counter-atom
            [type]="'kiosk'"
            [size]="'L'"
            [min]="0"
            [max]="maxProduct()"
            [backgroundColor]="buttonBackgroundColor() | contentBuilderColor"
            [textColor]="buttonTextColor() | contentBuilderColor"
            [count]="displayedQuantity() || 0"
            [acceptNoItem]="true"
            (countChange)="changeNbProduct($event); $any($event)?.stopPropagation?.()"
          ></app-counter-atom>
        </div>
      } @else {
        <div class="invisible">
          <!-- Use to keep all the card at the same height, if the counter is visible or not -->
          <app-counter-atom
            [type]="'kiosk'"
            [size]="'L'"
            [min]="0"
            [max]="maxProduct()"
            [backgroundColor]="buttonBackgroundColor() | contentBuilderColor"
            [textColor]="buttonTextColor() | contentBuilderColor"
            [count]="displayedQuantity() || 0"
            [acceptNoItem]="true"
          ></app-counter-atom>
        </div>
      }
    }

    @if (
      canSelect &&
      monoSelection() &&
      (product().quantity === 0 || !product().quantity) &&
      (!effectiveIsProductAvailable || !isOrderingAllowed())
    ) {
      <div class="flex flex-row items-center justify-center px-4">
        <app-button-atom
          size="S"
          [label]="'kiosk-product-card-atom.not-available' | translate"
          thickSize="XS"
          [overrideBgColor]="unavailableButtonBackground()"
          [overrideTextColor]="unavailableButtonText()"
          type="kiosk-light"
          [full]="true"
        ></app-button-atom>
      </div>
    }
  </div>
</div>
